module.exports = __webpack_public_path__ + "images/icon/add_binder_disable-20266e69.svg";